/**
 * Upload image to Cloudinary
 * Based on demo2 implementation
 * @param {File} file - The image file to upload
 * @param {string} folder - The Cloudinary folder path
 * @returns {Promise<{url: string, deleteToken?: string, publicId?: string}>}
 */
export const uploadImage = async (file, folder) => {
  const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET;

  if (!cloudName || !uploadPreset) {
    throw new Error('Cloudinary configuration missing. Please check your environment variables.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', folder);

  try {
    const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    const data = await response.json();
    
    return {
      url: data.secure_url || data.url,
      deleteToken: data.delete_token,
      publicId: data.public_id,
    };
  } catch (error) {
    console.error('Cloudinary upload error:', error);
    throw new Error(`Failed to upload image: ${error.message}`);
  }
};

/**
 * Build a Cloudinary folder path for Dkard images
 * @param {string} userId - The user ID
 * @param {string} vcardId - The vcard ID
 * @param {string} type - The type of image ('products' or 'gallery')
 * @returns {string}
 */
export const buildCloudinaryFolder = (userId, vcardId, type) => {
  return `dkard/users/${userId}/vcards/${vcardId}/${type}`;
};